import { FC } from "react";

import { Plus } from "lucide-react";
import { PureVoidFunc } from "../../../../../helpers/functions/types";
import { addComponetsButtonStyles } from "./helpers/addComponetsButtonStyles";

export const AddComponentsButton: FC<{
  valueTitle: string;
  onClick: PureVoidFunc;
  buttonText?: string;
  canAddExtraComponent: boolean;
  bigButton?: boolean;
  disabled?: boolean;
}> = ({
  valueTitle,
  buttonText,
  canAddExtraComponent,
  onClick,
  bigButton,
  disabled,
}) => {
  const { buttonStyles, iconStyles, textStyles } = addComponetsButtonStyles(
    !!buttonText?.length,
    bigButton,
  );
  return (
    <button
      id={`${valueTitle}AddInput`}
      className={buttonStyles}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      type="button"
      disabled={disabled}
    >
      <Plus
        className={`${iconStyles} ${canAddExtraComponent ? "" : "rotate-45"}`}
      />
      <span className={textStyles}>
        {buttonText ?? `Add ${valueTitle} value`}
      </span>
    </button>
  );
};
